var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtnWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45783 15.4754C1.54404 15.5616 1.65722 15.6045 1.7704 15.6045C1.88357 15.6045 1.99675 15.5611 2.08341 15.4749L8.40197 9.14883L14.7205 15.4749C14.8068 15.5616 14.9199 15.6045 15.0336 15.6045C15.1467 15.6045 15.2599 15.5611 15.3461 15.4754C15.519 15.3029 15.519 15.0231 15.3466 14.8502L9.03418 8.53077L15.3461 2.21176C15.5185 2.0389 15.5185 1.75904 15.3457 1.58662C15.1724 1.41376 14.893 1.41376 14.7205 1.58707L8.40153 7.91315L2.08296 1.58707C1.9101 1.4142 1.63025 1.4142 1.45783 1.58662C1.28496 1.75904 1.28496 2.0389 1.45739 2.21176L7.76888 8.53077L1.45739 14.8502C1.28496 15.0226 1.28496 15.3029 1.45783 15.4754Z",
    fill: "#191A1B",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnWhite);
export default __webpack_public_path__ + "static/media/closeBtnWhite.6c0c45f10e82279c9de28a16320b7de6.svg";
export { ForwardRef as ReactComponent };